"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colle-brianza": {
    "d984b43f": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "bindo": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7c8686c": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "piano": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04d92832": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "piecastello": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c51be0b": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "prato-san-pietro": [{
      "hkey": "8dfbd0c0",
      "slug": "colle-brianza",
      "name": "Colle Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;